import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { lightTheme as theme } from '../../theme';

const CardRoot = styled.div`
    position: relative;
    background: ${theme.colors.paper};
    border-radius: ${({ $radius }) => `${$radius}px`};
    border: 1px solid ${({ $borderColor }) => $borderColor};
    box-shadow: ${({ $shadow }) => $shadow};
    padding: ${({ $padding }) => (typeof $padding === 'number' ? `${$padding}px` : $padding)};
    overflow: hidden;

    ${({ $interactive }) =>
        $interactive &&
        css`
            cursor: pointer;
            transition: transform 0.2s ease, box-shadow 0.2s ease;

            &:hover {
                transform: translateY(-2px);
                box-shadow: ${theme.colors.shadowMd};
            }
        `}

    ${({ $leftIndicatorColor, $radius }) =>
        $leftIndicatorColor &&
        css`
            &::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                width: 4px;
                border-top-left-radius: ${$radius}px;
                border-bottom-left-radius: ${$radius}px;
                background: ${$leftIndicatorColor};
            }
        `}
`;

function SurfaceCard({
    children,
    onClick,
    interactive,
    leftIndicatorColor,
    padding,
    radius,
    borderColor,
    shadow,
    ...props
}) {
    const isClickable = Boolean(onClick) || interactive;
    const asType = isClickable ? 'button' : 'div';

    return (
        <CardRoot
            as={asType}
            type={asType === 'button' ? 'button' : undefined}
            onClick={onClick}
            $interactive={isClickable}
            $leftIndicatorColor={leftIndicatorColor}
            $padding={padding}
            $radius={radius}
            $borderColor={borderColor}
            $shadow={shadow}
            {...props}
        >
            {children}
        </CardRoot>
    );
}

SurfaceCard.propTypes = {
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func,
    interactive: PropTypes.bool,
    leftIndicatorColor: PropTypes.string,
    padding: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    radius: PropTypes.number,
    borderColor: PropTypes.string,
    shadow: PropTypes.string,
};

SurfaceCard.defaultProps = {
    onClick: undefined,
    interactive: false,
    leftIndicatorColor: undefined,
    padding: 16,
    radius: 12,
    borderColor: theme.colors.gray200,
    shadow: theme.colors.shadowSm,
};

export default SurfaceCard;

